import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { API_URL, useAxios } from "../../../utils/const";
import { useToast } from "../../../Context/ToastContext";
import * as XLSX from "xlsx";
import { useForm } from "react-hook-form";
import { Message } from "primereact/message";

export const ImportDosenModal = ({ toggleModal, getUsers }) => {

  const axiosInstance = useAxios();
  const { setToastObj } = useToast();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    toggleModal(false);
  };

  const importExcel = async (formData) => {
    setLoading(true);

    const file = formData.file[0];
    const reader = new FileReader();

    reader.onload = async (event) => {

      const workbook = XLSX.read(event.target.result, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const sheetData = XLSX.utils.sheet_to_json(sheet);

      // Upload to Backend
      try {
        await axiosInstance.post(`${API_URL}/users/import-dosen`, {
          dosen: sheetData
        });
        setLoading(false);
        getUsers();
        setToastObj({ msg: "Data Berhasil ditambahkan", type: "success" });
        closeModal();
      } catch (error) {
        let errorMessage = "Terjadi kesalahan";
        if (error.response.data.msg != undefined) {
          errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
        } else {
          errorMessage = error.message;
        }
        setLoading(false);
        setToastObj({
          msg: errorMessage,
          type: "danger",
        });
        closeModal();
      }
    }
    reader.readAsBinaryString(file);
  }

  return (
    <>
      <Modal size='md' show={toggleModal}>
        <Modal.Header>
          <Modal.Title>
            <h6>Import Dosen</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className='row my-4'>
            <div className='col-md-12'>
              <div className='form-group text-start'>
                <label className='form-label'>Upload Excel</label>
                <input
                  {...register("file", {
                    required: "File tidak boleh kosong!",
                  })}
                  type="file"
                  className="form-control"
                />
                {errors.file && (
                  <div className="">
                    <Message
                      className="mt-2 d-flex"
                      severity="error"
                      text={errors.file.message}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Batal
          </Button>
          <Button
            variant="success"
            disabled={loading}
            onClick={handleSubmit(importExcel)}
          >
            {loading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
            <span className="ml-1">Import</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
};
